//let commonUrl = 'https://kec.itzn.com.cn';

//let commonUrl = 'http://sms.com'
let commonUrl = 'http://smsapi.scedu.tech';
//let commonUrl = 'http://test.anyunxin.net';
let baseUrl = {
  commonUrl
}
export default baseUrl


// WEBPACK FOOTER //
// ./src/assets/js/base.js